import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import Navbar from '../components/Navbar';
import earth from '../Images/earth.jpg'; 
import 'typeface-poppins';
import 'typeface-raleway';

const OptimizeBanner = ({ onJoinClick, onLogoClick }) => {
  const words = ['Optimize', 'Save', 'Sustain'];
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [currentText, setCurrentText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const word = words[currentWordIndex];
    let typingSpeed = 200;

    const timeout = setTimeout(() => {
      if (isDeleting) {
        setCurrentText((prev) => prev.slice(0, prev.length - 1));
        typingSpeed = 50;
      } else {
        setCurrentText((prev) => word.substring(0, prev.length + 1));
      }

      if (!isDeleting && currentText === word) {
        setTimeout(() => setIsDeleting(true), 1500);
      } else if (isDeleting && currentText === '') {
        setIsDeleting(false);
        setCurrentWordIndex((prevIndex) => (prevIndex + 1) % words.length);
      }
    }, typingSpeed);

    return () => clearTimeout(timeout);
  }, [currentText, isDeleting, currentWordIndex, words]);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        height: '100vh',
        width: '100%',
        position: 'relative',
        overflow: 'hidden',
        boxSizing: 'border-box',
      }}
    >
      {/* Navbar */}
      <Navbar 
        onLogoClick={onLogoClick} 
        onJoinClick={onJoinClick} 
        isMobile={false} 
      />
      
      {/* Background Image */}
      <Box
        component="img"
        src={earth}
        alt="Background"
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: 0,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          width: '100%',
          height: '30%', // Adjust height as needed (e.g., 20%, 40%)
          background: 'linear-gradient(to top, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0))', // Black gradient from 50% opacity to 0%
          zIndex: 1, // Above the background image but below content
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '40%', // Adjust height as needed (e.g., 20%, 40%)
          background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0))', // Black gradient from 50% opacity to 0%
          zIndex: 1, // Above the background image but below content
        }}
      />
      {/* Fixed Text Background */}
      <Box
        sx={{
          position: 'relative',
          zIndex: 1,
          color: '#fff',
          backgroundColor: 'rgba(0, 0, 0, 0.4)',
          backdropFilter: 'blur(3px)', 
          padding: '3rem',
          height: '100vh',
          width: '50%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          textAlign: 'center',
          boxSizing: 'border-box',
          textShadow: '2px 4px 8px rgba(0, 0, 0, 0.8)',
        }}
      >
        {/* Typing Animation */}
        <Typography variant="h2" sx={{ fontWeight: 'bold', fontSize: '90px' }}>
          {currentText}
        </Typography>

        {/* Fixed Subtitle */}
        <Typography
          variant="h6"
          sx={{
            marginTop: '2rem',
            color: '#00d4ff',
            position: 'absolute',
            bottom: '35%',
            fontFamily: 'poppins',
            fontWeight: 'bold',
            fontSize: '33px',
            left: '15%',
            textShadow: '2px 4px 8px rgba(0, 0, 0, 0.8)',
          }}
        >
          All you want in one place
        </Typography>
      </Box>
    </Box>
  );
};

export default OptimizeBanner;
